import { ROUTES } from '../config/routes';
import type { Department, User } from '../types';

export function defaultRouteForUser(user: User | null, departments: Department[]): string {
  if (!user) return ROUTES.login;
  if (user.role === 'system_admin') return ROUTES.home;
  const department = departments.find(item => item.status === 'active' && user.departments.includes(item.id));
  return department ? ROUTES.home : ROUTES.unauthorized;
}
